<button
  [type]="buttonType()"
  class="flex flex-col items-stretch rounded-radius-primary py-2 px-3 text-sm font-bold transition-opacity"
  [ngClass]="[
    type() !== 'secondary-borderless' ? 'border' : '',
    disabled() ? 'opacity-40' : '',
    type() === 'primary' || type() === 'secondary' || type() === 'error' || type() === 'secondary-borderless'
      ? 'rounded-radius-primary'
      : '',
    type() === 'primary-v2' || type() === 'secondary-v2' || type() === 'error-v2' ? 'rounded-radius-secondary' : '',
    type() === 'secondary' ? 'border-custom-secondary-border' : '',
    type() === 'secondary' || type() === 'secondary-borderless' ? 'text-action-primary' : '',
    type() === 'secondary-v2' ? 'text-action-primary-text' : '',
    type() === 'primary' || type() === 'primary-v2' || type() === 'secondary-v2' ? 'border-action-primary' : '',
    type() === 'primary' || type() === 'primary-v2' ? 'bg-action-primary' : '',
    type() === 'primary' || type() === 'primary-v2' ? 'text-foreground-secondary-100' : '',
    type() === 'error' || type() === 'error-v2' ? 'border-status-error' : '',
    type() === 'error' || type() === 'error-v2' ? 'text-status-error-text' : '',
    customClasses(),
  ]"
  [disabled]="disabled()"
  (click)="onClick($event)"
>
  <ng-content></ng-content>
</button>
